import { z } from 'zod/v3';
import { NegotiationType } from '@/types/commercial/cart';

export const cartItemSchema = z
  .object({
    negotiationType: z.string().min(1, 'Selecione o tipo de negociação'),
    catalogItemId: z.string().min(1, 'Selecione um item'),
    quantity: z.number().int().min(1, 'Quantidade mínima é 1'),
    connectivityId: z.string().optional(),
    discountPercent: z.number().min(0).max(100).optional(),
    connectivityDiscountPercent: z.number().min(0).max(100).optional(),
  })
  .superRefine((data, ctx) => {
    if (data.negotiationType === NegotiationType.SALE_WITH_SIM_CARD) {
      if (!data.connectivityId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Selecione a conectividade',
          path: ['connectivityId'],
        });
      }
    }
  });

export type CartItemFormData = z.infer<typeof cartItemSchema>;
